// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --border-radius-xl: 30px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-primary: #6a11cb;
  --color-secondary: #f857a6;
  --color-success: #00b09b;
  --color-danger: #ff5858;
  --color-warning: #ffd166;
  --color-info: #4facfe;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-primary);
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  line-height: 1.6;
}

/* Container */
.VehicleMaterialcontainer {
  min-height: 100vh;
  background: var(--color-bg-secondary);
  padding: 0;
}

/* Header */

.Vehicle-header {
  position: relative;
  /* background: var(--land-gradient-purple); */
  background: linear-gradient(135deg, #c8a2c8 100%, #cadcfc 50%);
  color: white;
  padding: 1rem 1rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  border-radius: 0 0 0rem 0rem;
  box-shadow: var(--land-shadow-lg);
}

.Vehicle-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.Vehicle-animated-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: landFloat 6s ease-in-out infinite;
}

.Vehicle-shape-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.Vehicle-shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.Vehicle-shape-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation-delay: 4s;
}

.Vehicle-shape-4 {
  width: 120px;
  height: 120px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes landFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.Vehicle-header-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.Vehicle-title {
  /* font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem; */
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.Vehicle-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  font-weight: 300;
}
/*  */

.VehicleMaterialheader {
  background: var(--header-gradient);
  color: white;
  padding: 1rem 1rem;
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
}

.VehicleMaterialheader::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

.VehicleMaterialheader-content {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.VehicleMaterialheader-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.VehicleMaterialheader-subtitle {
  font-size: 1rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 400;
  text-align: center;
}

/* Main Content */
.VehicleMaterialmain-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

/* Loading State */
.VehicleMaterialloading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}

.VehicleMaterialloading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: VehicleMaterialspin 1s linear infinite;
  margin-bottom: 1.5rem;
}

.VehicleMaterialloading-content {
  max-width: 300px;
}

.VehicleMaterialloading-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialloading-text {
  color: var(--color-text-secondary);
  margin: 0;
}

@keyframes VehicleMaterialspin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Error State */
.VehicleMaterialerror-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 2rem;
}

.VehicleMaterialerror-icon {
  color: var(--color-danger);
  margin-bottom: 1.5rem;
  opacity: 0.8;
}

.VehicleMaterialerror-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialerror-text {
  color: var(--color-text-secondary);
  margin: 0 0 2rem 0;
  max-width: 400px;
}

.VehicleMaterialretry-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--primary-gradient);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-md);
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

.VehicleMaterialretry-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Unauthorized State */
.VehicleMaterialunauthorized-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 2rem;
}

.VehicleMaterialunauthorized-icon {
  color: var(--color-warning);
  margin-bottom: 1.5rem;
  opacity: 0.8;
}

.VehicleMaterialunauthorized-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialunauthorized-text {
  color: var(--color-text-secondary);
  margin: 0 0 0.5rem 0;
  max-width: 400px;
}

.VehicleMaterialunauthorized-subtext {
  color: var(--color-text-tertiary);
  margin: 0;
  font-size: 0.9rem;
}

/* Form Container */
.VehicleMaterialform-container {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.VehicleMaterialform-header {
  background: var(--card-gradient);
  padding: 2rem;
  border-bottom: 1px solid var(--color-border);
}

.VehicleMaterialform-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialform-title svg {
  color: var(--color-primary);
}

.VehicleMaterialform-description {
  color: var(--color-text-secondary);
  margin: 0;
}

/* Form */
.VehicleMaterialform {
  padding: 2rem;
}

.VehicleMaterialform-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.VehicleMaterialform-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.VehicleMaterialform-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.VehicleMaterialform-label svg {
  color: var(--color-primary);
}

.VehicleMaterialform-input,
.VehicleMaterialform-select {
  padding: 0.875rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  transition: var(--transition-fast);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
}

.VehicleMaterialform-input:focus,
.VehicleMaterialform-select:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.VehicleMaterialform-input:disabled,
.VehicleMaterialform-select:disabled {
  background: var(--color-bg-tertiary);
  color: var(--color-text-tertiary);
  cursor: not-allowed;
}

/* File Upload */
.VehicleMaterialfile-upload-group {
  grid-column: 1 / -1;
}

.VehicleMaterialfile-upload-wrapper {
  position: relative;
}

.VehicleMaterialfile-input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.VehicleMaterialfile-upload-display {
  border: 2px dashed var(--color-border);
  border-radius: var(--border-radius-md);
  padding: 2rem;
  text-align: center;
  transition: var(--transition-fast);
  background: var(--color-bg-secondary);
}

.VehicleMaterialfile-upload-display:hover {
  border-color: var(--color-primary);
  background: rgba(106, 17, 203, 0.02);
}

.VehicleMaterialfile-selected {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: var(--color-success);
  font-weight: 500;
}

.VehicleMaterialfile-placeholder {
  color: var(--color-text-secondary);
}

.VehicleMaterialfile-placeholder svg {
  color: var(--color-text-tertiary);
  margin-bottom: 1rem;
}

.VehicleMaterialfile-placeholder p {
  font-weight: 500;
  margin: 0 0 0.25rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialfile-placeholder span {
  font-size: 0.875rem;
  color: var(--color-text-tertiary);
}

/* Form Actions */
.VehicleMaterialform-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.VehicleMaterialsubmit-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: var(--border-radius-md);
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
  min-width: 180px;
  justify-content: center;
}

.VehicleMaterialsubmit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.VehicleMaterialsubmit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.VehicleMaterialbutton-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: VehicleMaterialspin 1s linear infinite;
}

/* Form Messages */
.VehicleMaterialform-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border-radius: var(--border-radius-md);
  font-weight: 500;
  margin-top: 1rem;
}

.VehicleMaterialform-error {
  background: rgba(255, 88, 88, 0.1);
  color: var(--color-danger);
  border: 1px solid rgba(255, 88, 88, 0.2);
}

.VehicleMaterialform-success {
  background: rgba(0, 176, 155, 0.1);
  color: var(--color-success);
  border: 1px solid rgba(0, 176, 155, 0.2);
}

/* Table Container */
.VehicleMaterialtable-container {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.VehicleMaterialtable-header {
  background: var(--card-gradient);
  padding: 2rem;
  border-bottom: 1px solid var(--color-border);
}

.VehicleMaterialtable-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialtable-title svg {
  color: var(--color-primary);
}

.VehicleMaterialtable-description {
  color: var(--color-text-secondary);
  margin: 0;
}

/* Table */
.VehicleMaterialtable-wrapper {
  overflow-x: auto;
}

.VehicleMaterialtable {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.VehicleMaterialtable th {
  background: var(--color-bg-tertiary);
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-text-primary);
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}

.VehicleMaterialtable td {
  padding: 1rem 0.75rem;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-secondary);
  vertical-align: middle;
}

.VehicleMaterialtable-row:hover {
  background: rgba(106, 17, 203, 0.02);
}

.VehicleMaterialtable-cell-index {
  font-weight: 600;
  color: var(--color-text-primary);
  text-align: center;
  width: 60px;
}

.VehicleMaterialtable-cell-vehicle {
  background-color: #c9eee2fc;
  font-weight: 500;
  color: var(--color-text-primary);
  padding: 5px;
  color: #01b075;
  border-radius: 50px;
}
.SiteName {
  background-color: #fbe5ea;
  padding: 5px;
  color: #88204b;
  font-weight: 600;
  border-radius: 50px;
}
.VehicleMaterialtable-cell-po {
  font-family: monospace;
  font-weight: 500;
  color: var(--color-primary);
}

.VehicleMaterialtable-cell-material {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.VehicleMaterialtable-cell-cost {
  font-weight: 600;
  color: var(--color-success);
}

.VehicleMaterialtable-cell-note {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Status Badge */
.VehicleMaterialstatus-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: var(--border-radius-xl);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.VehicleMaterialstatus-pending {
  background: rgba(255, 209, 102, 0.2);
  color: #b45309;
}

.VehicleMaterialstatus-completed,
.VehicleMaterialstatus-delivered {
  /* background: rgba(0, 176, 155, 0.2);
  color: var(--color-success); */
  background: #f8f5fb;
  color: #735da5;
}

.VehicleMaterialstatus-cancelled {
  background: rgba(255, 88, 88, 0.2);
  color: var(--color-danger);
}

.VehicleMaterialstatus-in-progress {
  background: rgba(79, 172, 254, 0.2);
  color: var(--color-info);
}

/* Image */
.VehicleMaterialimage-wrapper {
  display: flex;
  justify-content: center;
}

.VehicleMaterialtable-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: var(--border-radius-sm);
  border: 2px solid var(--color-border);
  transition: var(--transition-fast);
  cursor: pointer;
}

.VehicleMaterialtable-image:hover {
  transform: scale(1.1);
  box-shadow: var(--shadow-md);
}

.VehicleMaterialno-image {
  color: var(--color-text-tertiary);
  font-style: italic;
  font-size: 0.8rem;
}

/* No Data State */
.VehicleMaterialno-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: var(--color-text-secondary);
}

.VehicleMaterialno-data svg {
  color: var(--color-text-tertiary);
  margin-bottom: 1.5rem;
  opacity: 0.6;
}

.VehicleMaterialno-data h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialno-data p {
  margin: 0;
  max-width: 300px;
}

/* Controls Section */
.VehicleMaterialcontrols-section {
  /* background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md); */
  overflow: hidden;
  /* border: 1px solid var(--color-border); */
  margin-bottom: 2rem;
}

.VehicleMaterialcontrols-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--card-gradient);
}

.VehicleMaterialcontrols-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: var(--color-text-primary);
}

.VehicleMaterialadd-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  /* background: var(--primary-gradient); */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #01b075;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-md);
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

.VehicleMaterialadd-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.VehicleMaterialfilters-container {
  /* padding: 2rem; */
  display: flex;
  justify-content: space-between;
}

.VehicleMaterialsearch-container {
  width: 50%;
}

.VehicleMaterialsearch-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 500px;
}

.VehicleMaterialsearch-wrapper svg {
  position: absolute;
  left: 1rem;
  color: var(--color-text-tertiary);
  z-index: 1;
}

.VehicleMaterialsearch-input {
  width: 100%;
  padding: 0.45rem 1rem 0.45rem 3rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  transition: var(--transition-fast);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
}

.VehicleMaterialsearch-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.VehicleMaterialsearch-clear {
  position: absolute;
  right: 0.75rem;
  background: none;
  border: none;
  color: var(--color-text-tertiary);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: var(--border-radius-sm);
  transition: var(--transition-fast);
}

.VehicleMaterialsearch-clear:hover {
  color: var(--color-text-secondary);
  background: var(--color-bg-tertiary);
}

.VehicleMaterialfilters-wrapper {
  display: flex;
  align-items: end;
  gap: 1rem;
  flex-wrap: wrap;
}

.VehicleMaterialfilter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 150px;
}

.VehicleMaterialfilter-label {
  font-weight: 500;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.VehicleMaterialfilter-select {
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 0.9rem;
  transition: var(--transition-fast);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  cursor: pointer;
}

.VehicleMaterialfilter-select:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.VehicleMaterialclear-filters {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--color-bg-tertiary);
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
  padding: 0.75rem 1rem;
  border-radius: var(--border-radius-md);
  font-size: 0.9rem;
  cursor: pointer;
  transition: var(--transition-fast);
  height: fit-content;
}

.VehicleMaterialclear-filters:hover {
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
}

.VehicleMaterialresults-info {
  padding: 0 2rem 1rem;
  border-top: 1px solid var(--color-border);
  background: var(--color-bg-secondary);
}

.VehicleMaterialresults-info p {
  margin: 1rem 0 0 0;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

/* View Button */
.VehicleMaterialview-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: var(--color-info);
  color: white;
  border: none;
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius-sm);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
}

.VehicleMaterialview-button:hover {
  background: #3b82f6;
  transform: translateY(-1px);
}

/* PO Button */
.VehicleMaterialpo-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  /* background: var(--color-primary); */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #01b075;
  color: white;
  border: none;
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius-sm);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
}

.VehicleMaterialpo-button:hover {
  /* background: #5a0fb8; */
  transform: translateY(-1px);
}

.VehicleMaterialno-po {
  color: var(--color-text-tertiary);
  font-style: italic;
  font-size: 0.8rem;
}

/* Modal Styles */
.VehicleMaterialmodal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(4px);
}

.VehicleMaterialmodal-content {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid var(--color-border);
}

.VehicleMaterialmodal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--card-gradient);
}

.VehicleMaterialmodal-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: var(--color-text-primary);
}

.VehicleMaterialmodal-title svg {
  color: var(--color-primary);
}

.VehicleMaterialmodal-close {
  background: none;
  border: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: var(--border-radius-sm);
  transition: var(--transition-fast);
}

.VehicleMaterialmodal-close:hover {
  background: var(--color-bg-tertiary);
  color: var(--color-text-primary);
}

.VehicleMaterialmodal-form {
  padding: 2rem;
}

.VehicleMaterialmodal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.VehicleMaterialcancel-button {
  background: var(--color-bg-tertiary);
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
  padding: 0.875rem 1.5rem;
  border-radius: var(--border-radius-md);
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
}

.VehicleMaterialcancel-button:hover {
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
}

/* Image Modal */
.VehicleMaterialimage-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 1rem;
}

mid-content {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.VehicleMaterialimage-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--card-gradient);
}

.VehicleMaterialimage-modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: var(--color-text-primary);
}

.VehicleMaterialimage-modal-close {
  background: none;
  border: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: var(--border-radius-sm);
  transition: var(--transition-fast);
}

.VehicleMaterialimage-modal-close:hover {
  background: var(--color-bg-tertiary);
  color: var(--color-text-primary);
}

.VehicleMaterialimage-modal-body {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-bg-secondary);
}

.VehicleMaterialfullscreen-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
}

/* SIMPLE Purchase Order Modal */
.VehicleMaterialpo-modal-simple {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  border: 1px solid var(--color-border);
  animation: VehicleMaterialmodalFadeIn 0.3s ease-out;
}

.VehicleMaterialpo-modal-header-simple {
  /* background: var(--header-gradient); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  /* border-bottom: 1px solid var(--color-border); */
  padding: 1.25rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.VehicleMaterialpo-modal-title-simple {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.VehicleMaterialpo-modal-close-simple {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: var(--border-radius-sm);
  transition: var(--transition-fast);
}

.VehicleMaterialpo-modal-close-simple:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.VehicleMaterialpo-modal-body-simple {
  padding: 1.5rem;
  overflow-y: auto;
  max-height: calc(90vh - 80px);
  background: var(--color-bg-secondary);
}

.VehicleMaterialpo-details-simple {
  /* background: var(--color-bg-primary); */
  /* border-radius: var(--border-radius-sm); */
  /* padding: 1rem; */
  /* margin-bottom: 1.5rem; */
  /* border: 1px solid var(--color-border); */
  /* box-shadow: var(--shadow-sm); */
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
}

.VehicleMaterialpo-detail-row {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--color-border);
}

.VehicleMaterialpo-detail-row:last-child {
  border-bottom: none;
}

.VehicleMaterialpo-detail-label-simple {
  font-weight: 500;
  color: var(--color-text-primary);
  font-size: 0.85rem;
  min-width: 100px;
}

.VehicleMaterialpo-detail-value-simple {
  color: var(--color-text-secondary);
  font-size: 0.85rem;
  text-align: right;
  flex: 1 1;
}

/* Note Section */
.VehicleMaterialpo-note-simple {
  /* background: var(--color-bg-tertiary); */
  /* border: 1px solid var(--color-border); */
  /* border-radius: var(--border-radius-sm); */
  padding: 0.75rem;
  /* margin-bottom: 1.5rem; */
  color: var(--color-text-secondary);
  line-height: 1.4;
  font-size: 0.85rem;
}

.VehicleMaterialpo-note-simple strong {
  color: var(--color-text-primary);
}

/* Items Section */
.VehicleMaterialpo-items-section-simple {
  margin-top: 1.5rem;
}

.VehicleMaterialpo-items-title-simple {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 0.75rem 0;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid var(--color-primary);
}

/* Table Container */
.VehicleMaterialpo-table-container-simple {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-sm);
  /* overflow: hidden; */
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
}

.VehicleMaterialpo-table-simple {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.VehicleMaterialpo-table-simple thead {
  background: var(--color-bg-tertiary);
}

.VehicleMaterialpo-table-simple th {
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-border);
  white-space: nowrap;
  font-size: 0.8rem;
}

.VehicleMaterialpo-table-simple td {
  padding: 0.75rem;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-secondary);
  vertical-align: middle;
}

.VehicleMaterialpo-table-simple tbody tr:hover {
  background: var(--color-bg-tertiary);
}

.VehicleMaterialpo-table-index-simple {
  font-weight: 500;
  color: var(--color-text-primary);
  text-align: center;
  width: 40px;
}

.VehicleMaterialpo-table-material-simple {
  font-weight: 500;
  color: var(--color-text-primary);
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.VehicleMaterialpo-table-qty-simple,
.VehicleMaterialpo-table-received-simple,
.VehicleMaterialpo-table-remaining-simple {
  font-weight: 500;
  text-align: center;
  width: 70px;
}

.VehicleMaterialpo-table-received-simple {
  color: var(--color-success);
}

.VehicleMaterialpo-table-remaining-simple {
  color: var(--color-warning);
}

.VehicleMaterialpo-table-cost-simple,
.VehicleMaterialpo-table-total-simple {
  font-weight: 500;
  color: var(--color-success);
  text-align: right;
}

.VehicleMaterialpo-table-actions-simple {
  text-align: center;
  width: 120px;
}

/* Action Buttons */
.VehicleMaterialpo-add-btn-simple,
.VehicleMaterialpo-view-btn-simple {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
  margin: 0 0.2rem;
}

.VehicleMaterialpo-add-btn-simple {
  background: var(--color-success);
  color: white;
  margin-bottom: 5px;
}

.VehicleMaterialpo-add-btn-simple:hover {
  background: #008c76;
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.VehicleMaterialpo-view-btn-simple {
  background: var(--color-info);
  color: white;
}

.VehicleMaterialpo-view-btn-simple:hover {
  background: #3b82f6;
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* Status Badge Small */
.VehicleMaterialstatus-badge-small {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: var(--border-radius-md);
  font-size: 0.65rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* No Items State */
.VehicleMaterialpo-no-items-simple {
  text-align: center;
  padding: 1.5rem;
  color: var(--color-text-secondary);
  background: var(--color-bg-tertiary);
  border-radius: var(--border-radius-sm);
  border: 1px solid var(--color-border);
}

/* Update Quantity Modal */
.VehicleMaterialupdate-qty-modal-content {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid var(--color-border);
}

.VehicleMaterialupdate-qty-modal-body {
  padding: 2rem;
}

.VehicleMaterialupdate-qty-info {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: var(--color-bg-secondary);
  border-radius: var(--border-radius-md);
  border: 1px solid var(--color-border);
}

.VehicleMaterialupdate-qty-material-name {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: var(--color-text-primary);
}

.VehicleMaterialupdate-qty-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
}

.VehicleMaterialupdate-qty-detail {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.VehicleMaterialupdate-qty-detail label {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.VehicleMaterialupdate-qty-detail span {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text-primary);
  padding: 0.5rem 0.75rem;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-sm);
  border: 1px solid var(--color-border);
}

.VehicleMaterialupdate-qty-form {
  margin-top: 1.5rem;
}

.VehicleMaterialupdate-qty-helper {
  font-size: 0.8rem;
  color: var(--color-text-tertiary);
  margin-top: 0.25rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .VehicleMaterialheader {
    padding: 2rem 1rem;
  }

  .VehicleMaterialheader-title {
    font-size: 2rem;
  }

  .VehicleMaterialmain-content {
    padding: 0 1rem 2rem;
  }

  .VehicleMaterialform-grid {
    grid-template-columns: 1fr;
  }

  .VehicleMaterialform,
  .VehicleMaterialform-header,
  .VehicleMaterialtable-header {
    padding: 1.5rem;
  }

  .VehicleMaterialtable {
    font-size: 0.8rem;
  }

  .VehicleMaterialtable th,
  .VehicleMaterialtable td {
    padding: 0.75rem 0.5rem;
  }

  .VehicleMaterialform-actions {
    justify-content: stretch;
  }

  .VehicleMaterialsubmit-button {
    width: 100%;
  }

  .VehicleMaterialcontrols-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .VehicleMaterialadd-button {
    justify-content: center;
  }

  .VehicleMaterialfilters-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .VehicleMaterialsearch-container {
    width: 100%;
  }

  .VehicleMaterialfilters-wrapper {
    flex-direction: column;
    align-items: stretch;
  }

  .VehicleMaterialfilter-group {
    min-width: auto;
  }

  .VehicleMaterialsearch-wrapper {
    max-width: none;
  }

  .VehicleMaterialmodal-content,
  .VehicleMaterialpo-modal-simple {
    margin: 0.5rem;
    max-width: none;
  }

  .VehicleMaterialmodal-header,
  .VehicleMaterialmodal-form,
  .VehicleMaterialpo-modal-body-simple {
    padding: 1.5rem;
  }

  .VehicleMaterialmodal-actions {
    flex-direction: column;
  }

  .VehicleMaterialimage-modal-content {
    max-width: 95vw;
    max-height: 95vh;
  }

  .VehicleMaterialfullscreen-image {
    max-height: 60vh;
  }

  .VehicleMaterialpo-details-grid {
    grid-template-columns: 1fr;
  }

  .VehicleMaterialpo-modal-header-new {
    padding: 1.5rem;
  }

  .VehicleMaterialpo-modal-title-new {
    font-size: 1.5rem;
  }

  .VehicleMaterialpo-table-simple {
    font-size: 0.8rem;
  }

  .VehicleMaterialpo-table-simple th,
  .VehicleMaterialpo-table-simple td {
    padding: 0.5rem;
  }

  .VehicleMaterialpo-detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .VehicleMaterialpo-detail-label-simple {
    min-width: auto;
  }

  .VehicleMaterialpo-detail-value-simple {
    text-align: left;
  }

  .VehicleMaterialpo-add-btn-simple,
  .VehicleMaterialpo-view-btn-simple {
    padding: 0.3rem 0.6rem;
    font-size: 0.7rem;
    margin: 0.1rem;
    display: inline-block;
    width: auto;
  }

  .VehicleMaterialpo-table-actions-simple {
    width: 90px;
  }
}

@media (max-width: 480px) {
  .VehicleMaterialheader-title {
    font-size: 1.75rem;
  }

  .VehicleMaterialtable-wrapper {
    margin: 0 -1.5rem;
  }

  .VehicleMaterialtable {
    font-size: 0.75rem;
  }

  .VehicleMaterialtable th,
  .VehicleMaterialtable td {
    padding: 0.5rem 0.25rem;
  }

  .VehicleMaterialfilters-container {
    padding: 1rem;
  }

  .VehicleMaterialcontrols-header {
    padding: 1.5rem;
  }

  .VehicleMaterialresults-info {
    padding: 0 1rem 1rem;
  }

  .VehicleMaterialpo-detail-box {
    padding: 1rem;
  }

  .VehicleMaterialpo-detail-icon {
    min-width: 40px;
    min-height: 40px;
    padding: 0.75rem;
  }

  .VehicleMaterialpo-modal-header-simple {
    padding: 1rem;
  }

  .VehicleMaterialpo-modal-title-simple {
    font-size: 1.1rem;
  }
}

/* Print Styles */
@media print {
  .VehicleMaterialheader,
  .VehicleMaterialform-container {
    display: none;
  }

  .VehicleMaterialtable-container {
    box-shadow: none;
    border: 1px solid #000;
  }

  .VehicleMaterialtable th {
    background: #f0f0f0 !important;
  }
}

/* Animation for modal entrance */
@keyframes VehicleMaterialmodalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.VehicleMaterialmodal-content,
.VehicleMaterialimage-modal-content,
.VehicleMaterialpo-modal-simple {
  animation: VehicleMaterialmodalFadeIn 0.2s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/VehicleMaterial.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,kEAAkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,qCAAqC;EACrC,UAAU;AACZ;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,8DAA8D;EAC9D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;0BAEwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA,KAAK;;AAEL;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAyiB;EACziB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,SAAS;AACX;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE;gCAC8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE;;iCAE+B;EAC/B,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,iBAAiB;EACjB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,qBAAqB;EACrB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;EACxC,6DAA6D;EAC7D,kDAAkD;EAClD,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;EAC3C,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,SAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,sCAAsC;EACtC,sBAAsB;EACtB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,mBAAmB;AACnB;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,mCAAmC;EACnC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;;;EAGE,mDAAmD;AACrD","sourcesContent":[":root {\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --border-radius-xl: 30px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-primary: #6a11cb;\n  --color-secondary: #f857a6;\n  --color-success: #00b09b;\n  --color-danger: #ff5858;\n  --color-warning: #ffd166;\n  --color-info: #4facfe;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-primary);\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n  line-height: 1.6;\n}\n\n/* Container */\n.VehicleMaterialcontainer {\n  min-height: 100vh;\n  background: var(--color-bg-secondary);\n  padding: 0;\n}\n\n/* Header */\n\n.Vehicle-header {\n  position: relative;\n  /* background: var(--land-gradient-purple); */\n  background: linear-gradient(135deg, #c8a2c8 100%, #cadcfc 50%);\n  color: white;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  border-radius: 0 0 0rem 0rem;\n  box-shadow: var(--land-shadow-lg);\n}\n\n.Vehicle-header-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.Vehicle-animated-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: landFloat 6s ease-in-out infinite;\n}\n\n.Vehicle-shape-1 {\n  width: 100px;\n  height: 100px;\n  top: 20%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.Vehicle-shape-2 {\n  width: 150px;\n  height: 150px;\n  top: 60%;\n  right: 15%;\n  animation-delay: 2s;\n}\n\n.Vehicle-shape-3 {\n  width: 80px;\n  height: 80px;\n  bottom: 30%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.Vehicle-shape-4 {\n  width: 120px;\n  height: 120px;\n  top: 10%;\n  right: 30%;\n  animation-delay: 1s;\n}\n\n@keyframes landFloat {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n}\n\n.Vehicle-header-content {\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.Vehicle-title {\n  /* font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem; */\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.Vehicle-subtitle {\n  font-size: 1.125rem;\n  opacity: 0.9;\n  font-weight: 300;\n}\n/*  */\n\n.VehicleMaterialheader {\n  background: var(--header-gradient);\n  color: white;\n  padding: 1rem 1rem;\n  margin-bottom: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.VehicleMaterialheader::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n  pointer-events: none;\n}\n\n.VehicleMaterialheader-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.VehicleMaterialheader-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.VehicleMaterialheader-subtitle {\n  font-size: 1rem;\n  opacity: 0.9;\n  margin: 0;\n  font-weight: 400;\n  text-align: center;\n}\n\n/* Main Content */\n.VehicleMaterialmain-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Loading State */\n.VehicleMaterialloading-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n}\n\n.VehicleMaterialloading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid var(--color-border);\n  border-top: 4px solid var(--color-primary);\n  border-radius: 50%;\n  animation: VehicleMaterialspin 1s linear infinite;\n  margin-bottom: 1.5rem;\n}\n\n.VehicleMaterialloading-content {\n  max-width: 300px;\n}\n\n.VehicleMaterialloading-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialloading-text {\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n@keyframes VehicleMaterialspin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error State */\n.VehicleMaterialerror-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n  padding: 2rem;\n}\n\n.VehicleMaterialerror-icon {\n  color: var(--color-danger);\n  margin-bottom: 1.5rem;\n  opacity: 0.8;\n}\n\n.VehicleMaterialerror-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialerror-text {\n  color: var(--color-text-secondary);\n  margin: 0 0 2rem 0;\n  max-width: 400px;\n}\n\n.VehicleMaterialretry-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: var(--primary-gradient);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--border-radius-md);\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\n.VehicleMaterialretry-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Unauthorized State */\n.VehicleMaterialunauthorized-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n  padding: 2rem;\n}\n\n.VehicleMaterialunauthorized-icon {\n  color: var(--color-warning);\n  margin-bottom: 1.5rem;\n  opacity: 0.8;\n}\n\n.VehicleMaterialunauthorized-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialunauthorized-text {\n  color: var(--color-text-secondary);\n  margin: 0 0 0.5rem 0;\n  max-width: 400px;\n}\n\n.VehicleMaterialunauthorized-subtext {\n  color: var(--color-text-tertiary);\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n/* Form Container */\n.VehicleMaterialform-container {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialform-header {\n  background: var(--card-gradient);\n  padding: 2rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.VehicleMaterialform-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialform-title svg {\n  color: var(--color-primary);\n}\n\n.VehicleMaterialform-description {\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Form */\n.VehicleMaterialform {\n  padding: 2rem;\n}\n\n.VehicleMaterialform-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.VehicleMaterialform-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.VehicleMaterialform-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n}\n\n.VehicleMaterialform-label svg {\n  color: var(--color-primary);\n}\n\n.VehicleMaterialform-input,\n.VehicleMaterialform-select {\n  padding: 0.875rem 1rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  transition: var(--transition-fast);\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialform-input:focus,\n.VehicleMaterialform-select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.VehicleMaterialform-input:disabled,\n.VehicleMaterialform-select:disabled {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-tertiary);\n  cursor: not-allowed;\n}\n\n/* File Upload */\n.VehicleMaterialfile-upload-group {\n  grid-column: 1 / -1;\n}\n\n.VehicleMaterialfile-upload-wrapper {\n  position: relative;\n}\n\n.VehicleMaterialfile-input {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.VehicleMaterialfile-upload-display {\n  border: 2px dashed var(--color-border);\n  border-radius: var(--border-radius-md);\n  padding: 2rem;\n  text-align: center;\n  transition: var(--transition-fast);\n  background: var(--color-bg-secondary);\n}\n\n.VehicleMaterialfile-upload-display:hover {\n  border-color: var(--color-primary);\n  background: rgba(106, 17, 203, 0.02);\n}\n\n.VehicleMaterialfile-selected {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  color: var(--color-success);\n  font-weight: 500;\n}\n\n.VehicleMaterialfile-placeholder {\n  color: var(--color-text-secondary);\n}\n\n.VehicleMaterialfile-placeholder svg {\n  color: var(--color-text-tertiary);\n  margin-bottom: 1rem;\n}\n\n.VehicleMaterialfile-placeholder p {\n  font-weight: 500;\n  margin: 0 0 0.25rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialfile-placeholder span {\n  font-size: 0.875rem;\n  color: var(--color-text-tertiary);\n}\n\n/* Form Actions */\n.VehicleMaterialform-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n\n.VehicleMaterialsubmit-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 2rem;\n  border-radius: var(--border-radius-md);\n  font-weight: 500;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n  min-width: 180px;\n  justify-content: center;\n}\n\n.VehicleMaterialsubmit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.VehicleMaterialsubmit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.VehicleMaterialbutton-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: VehicleMaterialspin 1s linear infinite;\n}\n\n/* Form Messages */\n.VehicleMaterialform-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1rem;\n  border-radius: var(--border-radius-md);\n  font-weight: 500;\n  margin-top: 1rem;\n}\n\n.VehicleMaterialform-error {\n  background: rgba(255, 88, 88, 0.1);\n  color: var(--color-danger);\n  border: 1px solid rgba(255, 88, 88, 0.2);\n}\n\n.VehicleMaterialform-success {\n  background: rgba(0, 176, 155, 0.1);\n  color: var(--color-success);\n  border: 1px solid rgba(0, 176, 155, 0.2);\n}\n\n/* Table Container */\n.VehicleMaterialtable-container {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialtable-header {\n  background: var(--card-gradient);\n  padding: 2rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.VehicleMaterialtable-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialtable-title svg {\n  color: var(--color-primary);\n}\n\n.VehicleMaterialtable-description {\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Table */\n.VehicleMaterialtable-wrapper {\n  overflow-x: auto;\n}\n\n.VehicleMaterialtable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.VehicleMaterialtable th {\n  background: var(--color-bg-tertiary);\n  padding: 1rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.VehicleMaterialtable td {\n  padding: 1rem 0.75rem;\n  border-bottom: 1px solid var(--color-border);\n  color: var(--color-text-secondary);\n  vertical-align: middle;\n}\n\n.VehicleMaterialtable-row:hover {\n  background: rgba(106, 17, 203, 0.02);\n}\n\n.VehicleMaterialtable-cell-index {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-align: center;\n  width: 60px;\n}\n\n.VehicleMaterialtable-cell-vehicle {\n  background-color: #c9eee2fc;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  padding: 5px;\n  color: #01b075;\n  border-radius: 50px;\n}\n.SiteName {\n  background-color: #fbe5ea;\n  padding: 5px;\n  color: #88204b;\n  font-weight: 600;\n  border-radius: 50px;\n}\n.VehicleMaterialtable-cell-po {\n  font-family: monospace;\n  font-weight: 500;\n  color: var(--color-primary);\n}\n\n.VehicleMaterialtable-cell-material {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.VehicleMaterialtable-cell-cost {\n  font-weight: 600;\n  color: var(--color-success);\n}\n\n.VehicleMaterialtable-cell-note {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Status Badge */\n.VehicleMaterialstatus-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.VehicleMaterialstatus-pending {\n  background: rgba(255, 209, 102, 0.2);\n  color: #b45309;\n}\n\n.VehicleMaterialstatus-completed,\n.VehicleMaterialstatus-delivered {\n  /* background: rgba(0, 176, 155, 0.2);\n  color: var(--color-success); */\n  background: #f8f5fb;\n  color: #735da5;\n}\n\n.VehicleMaterialstatus-cancelled {\n  background: rgba(255, 88, 88, 0.2);\n  color: var(--color-danger);\n}\n\n.VehicleMaterialstatus-in-progress {\n  background: rgba(79, 172, 254, 0.2);\n  color: var(--color-info);\n}\n\n/* Image */\n.VehicleMaterialimage-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.VehicleMaterialtable-image {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: var(--border-radius-sm);\n  border: 2px solid var(--color-border);\n  transition: var(--transition-fast);\n  cursor: pointer;\n}\n\n.VehicleMaterialtable-image:hover {\n  transform: scale(1.1);\n  box-shadow: var(--shadow-md);\n}\n\n.VehicleMaterialno-image {\n  color: var(--color-text-tertiary);\n  font-style: italic;\n  font-size: 0.8rem;\n}\n\n/* No Data State */\n.VehicleMaterialno-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.VehicleMaterialno-data svg {\n  color: var(--color-text-tertiary);\n  margin-bottom: 1.5rem;\n  opacity: 0.6;\n}\n\n.VehicleMaterialno-data h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialno-data p {\n  margin: 0;\n  max-width: 300px;\n}\n\n/* Controls Section */\n.VehicleMaterialcontrols-section {\n  /* background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md); */\n  overflow: hidden;\n  /* border: 1px solid var(--color-border); */\n  margin-bottom: 2rem;\n}\n\n.VehicleMaterialcontrols-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--card-gradient);\n}\n\n.VehicleMaterialcontrols-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialadd-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  /* background: var(--primary-gradient); */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #01b075;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: var(--border-radius-md);\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\n.VehicleMaterialadd-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.VehicleMaterialfilters-container {\n  /* padding: 2rem; */\n  display: flex;\n  justify-content: space-between;\n}\n\n.VehicleMaterialsearch-container {\n  width: 50%;\n}\n\n.VehicleMaterialsearch-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: 500px;\n}\n\n.VehicleMaterialsearch-wrapper svg {\n  position: absolute;\n  left: 1rem;\n  color: var(--color-text-tertiary);\n  z-index: 1;\n}\n\n.VehicleMaterialsearch-input {\n  width: 100%;\n  padding: 0.45rem 1rem 0.45rem 3rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  transition: var(--transition-fast);\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialsearch-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.VehicleMaterialsearch-clear {\n  position: absolute;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  color: var(--color-text-tertiary);\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: var(--border-radius-sm);\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialsearch-clear:hover {\n  color: var(--color-text-secondary);\n  background: var(--color-bg-tertiary);\n}\n\n.VehicleMaterialfilters-wrapper {\n  display: flex;\n  align-items: end;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.VehicleMaterialfilter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 150px;\n}\n\n.VehicleMaterialfilter-label {\n  font-weight: 500;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n}\n\n.VehicleMaterialfilter-select {\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 0.9rem;\n  transition: var(--transition-fast);\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n  cursor: pointer;\n}\n\n.VehicleMaterialfilter-select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.VehicleMaterialclear-filters {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-border);\n  padding: 0.75rem 1rem;\n  border-radius: var(--border-radius-md);\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  height: fit-content;\n}\n\n.VehicleMaterialclear-filters:hover {\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialresults-info {\n  padding: 0 2rem 1rem;\n  border-top: 1px solid var(--color-border);\n  background: var(--color-bg-secondary);\n}\n\n.VehicleMaterialresults-info p {\n  margin: 1rem 0 0 0;\n  color: var(--color-text-secondary);\n  font-size: 0.9rem;\n}\n\n/* View Button */\n.VehicleMaterialview-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  background: var(--color-info);\n  color: white;\n  border: none;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialview-button:hover {\n  background: #3b82f6;\n  transform: translateY(-1px);\n}\n\n/* PO Button */\n.VehicleMaterialpo-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  /* background: var(--color-primary); */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #01b075;\n  color: white;\n  border: none;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialpo-button:hover {\n  /* background: #5a0fb8; */\n  transform: translateY(-1px);\n}\n\n.VehicleMaterialno-po {\n  color: var(--color-text-tertiary);\n  font-style: italic;\n  font-size: 0.8rem;\n}\n\n/* Modal Styles */\n.VehicleMaterialmodal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(4px);\n}\n\n.VehicleMaterialmodal-content {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialmodal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--card-gradient);\n}\n\n.VehicleMaterialmodal-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialmodal-title svg {\n  color: var(--color-primary);\n}\n\n.VehicleMaterialmodal-close {\n  background: none;\n  border: none;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: var(--border-radius-sm);\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialmodal-close:hover {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialmodal-form {\n  padding: 2rem;\n}\n\n.VehicleMaterialmodal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.VehicleMaterialcancel-button {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-border);\n  padding: 0.875rem 1.5rem;\n  border-radius: var(--border-radius-md);\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialcancel-button:hover {\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n}\n\n/* Image Modal */\n.VehicleMaterialimage-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n  padding: 1rem;\n}\n\nmid-content {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialimage-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--card-gradient);\n}\n\n.VehicleMaterialimage-modal-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialimage-modal-close {\n  background: none;\n  border: none;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: var(--border-radius-sm);\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialimage-modal-close:hover {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialimage-modal-body {\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: var(--color-bg-secondary);\n}\n\n.VehicleMaterialfullscreen-image {\n  max-width: 100%;\n  max-height: 70vh;\n  object-fit: contain;\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-md);\n}\n\n/* SIMPLE Purchase Order Modal */\n.VehicleMaterialpo-modal-simple {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  overflow: hidden;\n  border: 1px solid var(--color-border);\n  animation: VehicleMaterialmodalFadeIn 0.3s ease-out;\n}\n\n.VehicleMaterialpo-modal-header-simple {\n  /* background: var(--header-gradient); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  /* border-bottom: 1px solid var(--color-border); */\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n}\n\n.VehicleMaterialpo-modal-title-simple {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.VehicleMaterialpo-modal-close-simple {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: var(--border-radius-sm);\n  transition: var(--transition-fast);\n}\n\n.VehicleMaterialpo-modal-close-simple:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.VehicleMaterialpo-modal-body-simple {\n  padding: 1.5rem;\n  overflow-y: auto;\n  max-height: calc(90vh - 80px);\n  background: var(--color-bg-secondary);\n}\n\n.VehicleMaterialpo-details-simple {\n  /* background: var(--color-bg-primary); */\n  /* border-radius: var(--border-radius-sm); */\n  /* padding: 1rem; */\n  /* margin-bottom: 1.5rem; */\n  /* border: 1px solid var(--color-border); */\n  /* box-shadow: var(--shadow-sm); */\n  display: flex;\n  flex-wrap: wrap;\n  gap: 25px;\n}\n\n.VehicleMaterialpo-detail-row {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.VehicleMaterialpo-detail-row:last-child {\n  border-bottom: none;\n}\n\n.VehicleMaterialpo-detail-label-simple {\n  font-weight: 500;\n  color: var(--color-text-primary);\n  font-size: 0.85rem;\n  min-width: 100px;\n}\n\n.VehicleMaterialpo-detail-value-simple {\n  color: var(--color-text-secondary);\n  font-size: 0.85rem;\n  text-align: right;\n  flex: 1;\n}\n\n/* Note Section */\n.VehicleMaterialpo-note-simple {\n  /* background: var(--color-bg-tertiary); */\n  /* border: 1px solid var(--color-border); */\n  /* border-radius: var(--border-radius-sm); */\n  padding: 0.75rem;\n  /* margin-bottom: 1.5rem; */\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  font-size: 0.85rem;\n}\n\n.VehicleMaterialpo-note-simple strong {\n  color: var(--color-text-primary);\n}\n\n/* Items Section */\n.VehicleMaterialpo-items-section-simple {\n  margin-top: 1.5rem;\n}\n\n.VehicleMaterialpo-items-title-simple {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0 0 0.75rem 0;\n  padding-bottom: 0.25rem;\n  border-bottom: 2px solid var(--color-primary);\n}\n\n/* Table Container */\n.VehicleMaterialpo-table-container-simple {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-sm);\n  /* overflow: hidden; */\n  border: 1px solid var(--color-border);\n  box-shadow: var(--shadow-sm);\n}\n\n.VehicleMaterialpo-table-simple {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.VehicleMaterialpo-table-simple thead {\n  background: var(--color-bg-tertiary);\n}\n\n.VehicleMaterialpo-table-simple th {\n  padding: 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-border);\n  white-space: nowrap;\n  font-size: 0.8rem;\n}\n\n.VehicleMaterialpo-table-simple td {\n  padding: 0.75rem;\n  border-bottom: 1px solid var(--color-border);\n  color: var(--color-text-secondary);\n  vertical-align: middle;\n}\n\n.VehicleMaterialpo-table-simple tbody tr:hover {\n  background: var(--color-bg-tertiary);\n}\n\n.VehicleMaterialpo-table-index-simple {\n  font-weight: 500;\n  color: var(--color-text-primary);\n  text-align: center;\n  width: 40px;\n}\n\n.VehicleMaterialpo-table-material-simple {\n  font-weight: 500;\n  color: var(--color-text-primary);\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.VehicleMaterialpo-table-qty-simple,\n.VehicleMaterialpo-table-received-simple,\n.VehicleMaterialpo-table-remaining-simple {\n  font-weight: 500;\n  text-align: center;\n  width: 70px;\n}\n\n.VehicleMaterialpo-table-received-simple {\n  color: var(--color-success);\n}\n\n.VehicleMaterialpo-table-remaining-simple {\n  color: var(--color-warning);\n}\n\n.VehicleMaterialpo-table-cost-simple,\n.VehicleMaterialpo-table-total-simple {\n  font-weight: 500;\n  color: var(--color-success);\n  text-align: right;\n}\n\n.VehicleMaterialpo-table-actions-simple {\n  text-align: center;\n  width: 120px;\n}\n\n/* Action Buttons */\n.VehicleMaterialpo-add-btn-simple,\n.VehicleMaterialpo-view-btn-simple {\n  display: inline-block;\n  padding: 0.4rem 0.8rem;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  margin: 0 0.2rem;\n}\n\n.VehicleMaterialpo-add-btn-simple {\n  background: var(--color-success);\n  color: white;\n  margin-bottom: 5px;\n}\n\n.VehicleMaterialpo-add-btn-simple:hover {\n  background: #008c76;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.VehicleMaterialpo-view-btn-simple {\n  background: var(--color-info);\n  color: white;\n}\n\n.VehicleMaterialpo-view-btn-simple:hover {\n  background: #3b82f6;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Status Badge Small */\n.VehicleMaterialstatus-badge-small {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.5rem;\n  border-radius: var(--border-radius-md);\n  font-size: 0.65rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* No Items State */\n.VehicleMaterialpo-no-items-simple {\n  text-align: center;\n  padding: 1.5rem;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-tertiary);\n  border-radius: var(--border-radius-sm);\n  border: 1px solid var(--color-border);\n}\n\n/* Update Quantity Modal */\n.VehicleMaterialupdate-qty-modal-content {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialupdate-qty-modal-body {\n  padding: 2rem;\n}\n\n.VehicleMaterialupdate-qty-info {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: var(--color-bg-secondary);\n  border-radius: var(--border-radius-md);\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialupdate-qty-material-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n  color: var(--color-text-primary);\n}\n\n.VehicleMaterialupdate-qty-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 1rem;\n}\n\n.VehicleMaterialupdate-qty-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.VehicleMaterialupdate-qty-detail label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.VehicleMaterialupdate-qty-detail span {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  padding: 0.5rem 0.75rem;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-sm);\n  border: 1px solid var(--color-border);\n}\n\n.VehicleMaterialupdate-qty-form {\n  margin-top: 1.5rem;\n}\n\n.VehicleMaterialupdate-qty-helper {\n  font-size: 0.8rem;\n  color: var(--color-text-tertiary);\n  margin-top: 0.25rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .VehicleMaterialheader {\n    padding: 2rem 1rem;\n  }\n\n  .VehicleMaterialheader-title {\n    font-size: 2rem;\n  }\n\n  .VehicleMaterialmain-content {\n    padding: 0 1rem 2rem;\n  }\n\n  .VehicleMaterialform-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .VehicleMaterialform,\n  .VehicleMaterialform-header,\n  .VehicleMaterialtable-header {\n    padding: 1.5rem;\n  }\n\n  .VehicleMaterialtable {\n    font-size: 0.8rem;\n  }\n\n  .VehicleMaterialtable th,\n  .VehicleMaterialtable td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .VehicleMaterialform-actions {\n    justify-content: stretch;\n  }\n\n  .VehicleMaterialsubmit-button {\n    width: 100%;\n  }\n\n  .VehicleMaterialcontrols-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .VehicleMaterialadd-button {\n    justify-content: center;\n  }\n\n  .VehicleMaterialfilters-container {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  .VehicleMaterialsearch-container {\n    width: 100%;\n  }\n\n  .VehicleMaterialfilters-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .VehicleMaterialfilter-group {\n    min-width: auto;\n  }\n\n  .VehicleMaterialsearch-wrapper {\n    max-width: none;\n  }\n\n  .VehicleMaterialmodal-content,\n  .VehicleMaterialpo-modal-simple {\n    margin: 0.5rem;\n    max-width: none;\n  }\n\n  .VehicleMaterialmodal-header,\n  .VehicleMaterialmodal-form,\n  .VehicleMaterialpo-modal-body-simple {\n    padding: 1.5rem;\n  }\n\n  .VehicleMaterialmodal-actions {\n    flex-direction: column;\n  }\n\n  .VehicleMaterialimage-modal-content {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n\n  .VehicleMaterialfullscreen-image {\n    max-height: 60vh;\n  }\n\n  .VehicleMaterialpo-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .VehicleMaterialpo-modal-header-new {\n    padding: 1.5rem;\n  }\n\n  .VehicleMaterialpo-modal-title-new {\n    font-size: 1.5rem;\n  }\n\n  .VehicleMaterialpo-table-simple {\n    font-size: 0.8rem;\n  }\n\n  .VehicleMaterialpo-table-simple th,\n  .VehicleMaterialpo-table-simple td {\n    padding: 0.5rem;\n  }\n\n  .VehicleMaterialpo-detail-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n\n  .VehicleMaterialpo-detail-label-simple {\n    min-width: auto;\n  }\n\n  .VehicleMaterialpo-detail-value-simple {\n    text-align: left;\n  }\n\n  .VehicleMaterialpo-add-btn-simple,\n  .VehicleMaterialpo-view-btn-simple {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.7rem;\n    margin: 0.1rem;\n    display: inline-block;\n    width: auto;\n  }\n\n  .VehicleMaterialpo-table-actions-simple {\n    width: 90px;\n  }\n}\n\n@media (max-width: 480px) {\n  .VehicleMaterialheader-title {\n    font-size: 1.75rem;\n  }\n\n  .VehicleMaterialtable-wrapper {\n    margin: 0 -1.5rem;\n  }\n\n  .VehicleMaterialtable {\n    font-size: 0.75rem;\n  }\n\n  .VehicleMaterialtable th,\n  .VehicleMaterialtable td {\n    padding: 0.5rem 0.25rem;\n  }\n\n  .VehicleMaterialfilters-container {\n    padding: 1rem;\n  }\n\n  .VehicleMaterialcontrols-header {\n    padding: 1.5rem;\n  }\n\n  .VehicleMaterialresults-info {\n    padding: 0 1rem 1rem;\n  }\n\n  .VehicleMaterialpo-detail-box {\n    padding: 1rem;\n  }\n\n  .VehicleMaterialpo-detail-icon {\n    min-width: 40px;\n    min-height: 40px;\n    padding: 0.75rem;\n  }\n\n  .VehicleMaterialpo-modal-header-simple {\n    padding: 1rem;\n  }\n\n  .VehicleMaterialpo-modal-title-simple {\n    font-size: 1.1rem;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .VehicleMaterialheader,\n  .VehicleMaterialform-container {\n    display: none;\n  }\n\n  .VehicleMaterialtable-container {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n\n  .VehicleMaterialtable th {\n    background: #f0f0f0 !important;\n  }\n}\n\n/* Animation for modal entrance */\n@keyframes VehicleMaterialmodalFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.VehicleMaterialmodal-content,\n.VehicleMaterialimage-modal-content,\n.VehicleMaterialpo-modal-simple {\n  animation: VehicleMaterialmodalFadeIn 0.2s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
